<template>
    <div class="simple-banner mt-8">
        <a href="/" class="simple-banner__link">
            <img src="https://cf.shopee.co.th/file/th-50009109-4511584405faf59f920c914b3bee8be5" class="simple-banner__img">
        </a>
    </div>
</template>

<script>
export default {
    name: 'SimpleBanner'
}
</script>
